import React from 'react'

function Error() {
    return (
        <div className='d-flex justify-content-center'>
            <div className='card p-4 m-4 text-center w-50'>
                <h5 className='text text-secondary'>Oups!! Une erreur s'est produite</h5>
            </div>
        </div>
    )
}

export default Error